import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//
import { doAccessAction } from 'store/actions/role-list.actions';
import { ROLES, API_METHODS } from 'config/constants';
import { getUserRoleLabel } from 'utils/business-logic/getUserRoleFromGroupsList';
import { Loader } from 'components';
import { BUS_USER_IS_BLOCKED } from 'config/error-codes-dictionary';
import ComplexSuccessIcon from 'components/SvgIcons/ComplexIcons/success.svg';
import ComplexCrossIcon from 'components/SvgIcons/ComplexIcons/cross.svg';
import { MODAL_TYPES } from '../constants';
import { NotesForm } from './NotesForm';
import { getConnectDescription } from './getConnectionDescription';

@connect(
  ({ roleList: { processing = {}, sponsorProfileRequests = {} } }, props) => ({
    processing: processing[`connect-${props.options.userId}`],
    sponsorProfileRequests,
  }),
  (dispatch) => ({
    doAccessAction: bindActionCreators(doAccessAction, dispatch),
  }),
)
export class ConnectModal extends React.PureComponent {
  static propTypes = {
    doAccessAction: PropTypes.func,
    options: PropTypes.shape({
      userRole: PropTypes.string,
      userId: PropTypes.string,
      listDataKey: PropTypes.string,
      actionCb: PropTypes.func,
    }),
    groups: PropTypes.array,
  };

  static defaultProps = {
    options: {},
  };

  handleSubmit = async (values) => {
    const {
      showModal,
      doAccessAction,
      options: {
        userRole,
        userId,
        listDataKey,
        actionCb,
        handleReloadPage,
      } = {},
    } = this.props;
    let url;
    let requestMethod = 'post';

    switch (userRole) {
      case ROLES.SPONSOR:
        url = API_METHODS.ACCESS_REQUEST_SPONSOR;
        break;
      case ROLES.RESEARCH_SITE:
        url = API_METHODS.ACCESS_REQUEST_RESEARCH_SITE;
        break;
      case ROLES.INACTIVE_RESEARCH_SITE:
        url = API_METHODS.INACTIVE_RESEARCH_INVITE(userId);
        requestMethod = 'put';
        break;
      case ROLES.INACTIVE_SPONSOR:
        url = API_METHODS.INACTIVE_SPONSOR_INVITE(userId);
        requestMethod = 'put';
        break;
      default:
        throw new Error('Unknown user role');
    }

    const response = await doAccessAction({
      requestMethod,
      url,
      body: { ...values, recipientId: userId },
      userId,
      processingKey: `connect-${userId}`,
      stateKeyForDataSaving: listDataKey,
      rewriteAccessRequestKey: 'id',
    });

    if (!response || response.code !== 'success') {
      const { errors = [] } = response;
      const isBlocked = errors.find(
        (item) => item.code === BUS_USER_IS_BLOCKED,
      );

      if (isBlocked) {
        return showModal(MODAL_TYPES.BLOCKED, { reason: isBlocked.message });
      }

      return showModal(MODAL_TYPES.INFO, {
        withCross: false,
        icon: <ComplexCrossIcon />,
        text: 'Ooops….something went wrong.',
        body: 'Your request is not sent. Please try again later.',
        additionalClassName: 'p-15',
      });
    }

    showModal(MODAL_TYPES.INFO, {
      withCross: false,
      icon: <ComplexSuccessIcon />,
      text: 'Done. Your request has been sent.',
      body: 'You can track the status of the request in your sent requests dashboard.',
      additionalClassName: 'p-15',
      handleReloadPage: handleReloadPage,
    });
    actionCb && actionCb();
  };

  render() {
    const { options: { userRole } = {} } = this.props;

    const roleLabel = getUserRoleLabel(userRole);

    return (
      <Loader isShow={this.props.processing}>
        <div className="white-box p-15 text-left" style={{ maxWidth: '550px' }}>
          <div className="montserrat bold fs-16">{`Connect with ${roleLabel}`}</div>
          <div className="fs-12 mt-2">{getConnectDescription(userRole)}</div>
          <NotesForm
            notesPlaceholder={`Add notes for ${roleLabel}`}
            onSubmit={this.handleSubmit}
          />
        </div>
      </Loader>
    );
  }
}
